<template>
  <router-link
    v-if="modern"
    :to="`/${feature.slug}`"
    class="flex flex-col rounded-lg overflow-hidden shadow-lg hover:opacity-70 bg-zinc-100 dark:bg-gray-800"
  >
    <FeatureIcon :feature="feature" modern />
    <div class="p-4">
      <h3 class="text-lg font-bold text-primary-dark dark:text-primary-light">
        {{ feature.name }}
      </h3>
      <div class="mt-2 text-sm lg:text-base text-normal">{{ feature.description }}</div>
    </div>
  </router-link>

  <router-link
    v-else
    :to="`/${feature.slug}`"
    class="p-4 w-full shadow-lg flex flex-col space-y-4 hover:bg-blue-50 transition bg-zinc-50 dark:bg-gray-800 dark:hover:bg-sky-900"
  >
    <div class="flex space-x-2 items-center">
      <FeatureIcon :feature="feature" class="feature-icon" />
      <h3 class="text-lg font-bold text-primary-dark dark:text-primary-light">
        {{ feature.name }}
      </h3>
    </div>

    <div>
      <div class="text-sm lg:text-base text-normal">{{ feature.description }}</div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
  import FeatureIcon from '&/FeatureIcon.vue'

  withDefaults(
    defineProps<{
      feature: object
      modern?: boolean
    }>(),
    {
      modern: false,
    },
  )
</script>

<style scoped lang="scss">
  .feature-icon {
    width: 25%;
  }
</style>
